const TWEEN = {
    DURATION: 250,
    EASE: Phaser.Math.Easing.Linear,
    ALPHA: 0.85,
};

export default class Fade extends Phaser.GameObjects.Sprite {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, 'atlas', 'blank');

        let width = this.scene.cameras.main.width;
        let height = this.scene.cameras.main.height;

        this.setDisplaySize(width, height);
        this.setTint(0x000000);
        this.setInteractive();
        this.setAlpha(0);
    }

    show(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                alpha: TWEEN.ALPHA,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE,
                onComplete: () => resolve(),
            });
        });
    }

    hide(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE,
                onComplete: () => resolve(),
            });
        });
    }
}
